import { VueModule } from '@Foundation/utilities';
import SustainabilityModuleV2 from './code/Scripts/components/sustainability-module-v2.vue';

export default VueModule({
  components: {
    SustainabilityModuleV2
  }
});
